const mime = require('mime-types');

export function getFileBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const dataUrl = reader.result;
      const base64 = dataUrl.split(',')[1];
      resolve(base64);
    };

    reader.onerror = reject;

    reader.readAsDataURL(file);
  });
}

export function getFileBase64Url(base64Content, fileName) {
  let contentType = mime.lookup(fileName);
  let url = 'data:' + contentType + ';base64,' + base64Content;

  return url;
}

export function getFileExtension(fileName) {
  if (!fileName) {
    return '';
  }

  const parts = String(fileName).split('.');

  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

export function getFileContentType(fileName) {
  return mime.lookup(fileName || '') || 'application/octet-stream';
}

export function convertBase64toBlob(content, contentType) {
  contentType = contentType || '';
  const sliceSize = 512;
  const byteCharacters = window.atob(content);
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    let slice = byteCharacters.slice(offset, offset + sliceSize);
    let byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    let byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  let blob = new Blob(byteArrays, {
    type: contentType
  });
  return blob;
}
